<div class="flex-container">
  <button
    *ngIf="showBackButton"
    mat-button
    class="action-button"
    (click)="goBack()"
  >
    <img src="/assets/images/icons/left-arrow.svg" alt="" />
  </button>

  <div class="action-co">
    <button mat-button class="action-button" (click)="shareProduct()">
      <img src="/assets/images/icons/share-icon.svg" alt="" />
    </button>
    <button mat-button class="action-button" (click)="handleFavClick()">
      <img
        [src]="
          product.is_favorite
            ? '/assets/images/icons/like-icon.svg'
            : '/assets/images/icons/heart-empty.svg'
        "
        alt=""
      />
    </button>
  </div>
</div>

<ng-template #share>
  <div class="share-sheet-container">
    <p>Share Product</p>
    <br />
    <div class="icons">
      <button
        (click)="sendShareEvent('copy')"
        mat-mini-fab
        [cdkCopyToClipboard]="productUrl"
        (cdkCopyToClipboardCopied)="tooltip.show()"
      >
        <mat-icon>file_copy</mat-icon>
      </button>
      <button mat-mini-fab (click)="shareWithMail()">
        <mat-icon>mail</mat-icon>
      </button>
    </div>
    <span
      #tooltip="matTooltip"
      matTooltip="{{ 'summaryPage.copied' | translate }}"
    ></span>
  </div>
</ng-template>
